import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import EntityFormComponent from './EntityFormComponent';
import EntityPaymentPage from './EntityPaymentPage';
import images from './images/images';
import { dwhEntityPaymentEntrance, dwhEntityPaymentSuccess, dwhEntityPaymentFailure } from '../UpdatePaymentMethodBlock/dwhReports';

const EntityPayment = (props) => {
  const [currentStep, setCurrentStep] = useState('welcome');
  const [formData, setFormData] = useState(null);
  const [entityDetails, setEntityDetails] = useState(null);
  const magicLinkParameters = props.magicLinkParameters;
  console.log(props);

  useEffect(() => {
    if (magicLinkParameters) {
      if (magicLinkParameters.entityDetails) {
        try {
          const parsedEntityDetails = JSON.parse(magicLinkParameters.entityDetails);
          setEntityDetails(parsedEntityDetails);
        } catch (error) {
        }
      }
    }

    // Report 3: EntityPayment component entrance
    let accountsToUpdate = '';
    try {
      if (magicLinkParameters?.entityDetails) {
        const parsed = JSON.parse(magicLinkParameters.entityDetails);
        accountsToUpdate = Object.values(parsed)
          .flat()
          .map(acc => acc.number)
          .join(',');
      } else if (entityDetails) {
        accountsToUpdate = Object.values(entityDetails)
          .flat()
          .map(acc => acc.number)
          .join(',');
      }
    } catch (e) {
      accountsToUpdate = '';
    }

    dwhEntityPaymentEntrance({
      customerName: props.userDetails?.fullName || magicLinkParameters?.fullName || '',
      subscriber: props.userDetails?.contactNumber || '',
      idNumber: props.userDetails?.idNumber || magicLinkParameters?.idNumber,
      oldCreditCardLast4: '',
      accountsToUpdate,
      smsPhoneNumber: props.userDetails.contactNumber || '',
      newPaymentMethodLast4: '',
      subscriberNumber: props.selectedSubscriber || '',
      banId: accountsToUpdate,
      email: ''
    });
  }, [magicLinkParameters]);

  const handleButtonClick = () => {
    setCurrentStep('form');
  };

  const handleFormSubmit = (data) => {
    setFormData(data);
    setCurrentStep('payment');
  };

  const handleBackToForm = () => {
    setCurrentStep('form');
  };

  const handlePaymentSuccess = (successData) => {
    dwhEntityPaymentSuccess({
      customerName: props.userDetails?.fullName || magicLinkParameters?.fullName || '',
      subscriber: props.userDetails?.contactNumber || '',
      idNumber: props.userDetails?.idNumber || magicLinkParameters?.idNumber,
      oldCreditCardLast4: '',
      accountsToUpdate: successData?.accountList?.join(',') || '',
      smsPhoneNumber: props.userDetails.contactNumber || '',
      newPaymentMethodLast4: successData?.newCreditCardLast4 || '',
      subscriberNumber: props.selectedSubscriber || '',
      banId: successData?.accountList?.join(',') || '',
      email: ''
    });
  };

  const handlePaymentFailure = (errorData) => {
    dwhEntityPaymentFailure({
      customerName: props.userDetails?.fullName || magicLinkParameters?.fullName || '',
      subscriber: props.userDetails?.contactNumber || '',
      idNumber: props.userDetails?.idNumber || magicLinkParameters?.idNumber,
      oldCreditCardLast4: '',
      accountsToUpdate: entityDetails ? Object.values(entityDetails).flat().map(acc => acc.number).join(',') : '',
      smsPhoneNumber: props.userDetails.contactNumber || '',
      newPaymentMethodLast4: '',
      subscriberNumber: props.selectedSubscriber || '',
      banId: entityDetails ? Object.values(entityDetails).flat().map(acc => acc.number).join(',') : '',
      email: ''
    });
  };

  return (
    <div className='main-entity-payment-page-wrapper'>
      <div className="content">
        {currentStep === 'welcome' && (
          <div className='welcome-entity-payment-page-wrapper'>
            <div className="icon120">
              <Image src={images.updateicon} className="iconheadline" />
            </div>
            <span className="welcome-title-text">
              קיבלת הזמנה מ{magicLinkParameters?.fullName} לעדכן את אמצעי התשלום בחשבונות {window.Config.brand_Name_HE}
            </span>
            <div className='accounts-frame'>
              <span className="account-title">
              החשבונות שיעודכנו
              </span>

              {entityDetails && (
                <div className="entity-details">
                  {Object.entries(entityDetails).map(([entityId, accounts]) => (
                    <div key={entityId} className="entity-group">
                      <div className="entity-accounts-list">
                        {accounts.map((account, index) => (
                          <div key={index} className="entity-account-item">
                            <span className="entity-account-number">
                              חשבון {account.number}
                            </span>
                            <span className="entity-account-name">
                              {' '} {account.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="btn-container">
              <button className="next-button" onClick={handleButtonClick}>
                <span className='button-text'>
                  המשך לעדכון פרטי המשלם
                </span>
              </button>
            </div>
          </div>
        )}

        {currentStep === 'form' && (
          <EntityFormComponent
            {...props}
            magicLinkParameters={magicLinkParameters}
            onFormSubmit={handleFormSubmit}
          />
        )}

        {currentStep === 'payment' && (
          <EntityPaymentPage
            {...props}
            formData={formData}
            magicLinkParameters={magicLinkParameters}
            customerId={formData?.id}
            onBack={handleBackToForm}
            onPaymentSuccess={handlePaymentSuccess}
            onPaymentFailure={handlePaymentFailure}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    magicLinkParameters: state.authentication?.loginData?.magicLinkParameters,
    userDetails: state.authentication?.loginData?.userDetails,
    selectedSubscriber: state.authentication?.loginData?.selectedSubscriber,
    isAuthenticated: state.authentication?.loginData?.isFullAuthenticated ||
                    state.authentication?.loginData?.isOtpAuthenticated ||
                    state.authentication?.loginData?.isOtpExtendedAuthenticated ||
                    state.authentication?.loginData?.isSilentOtpAuthenticated,
  };
};

export default connect(mapStateToProps)(EntityPayment);
